import { useEffect, useRef, useState } from 'react';

/**
 * Puts focus back on a button that was off screen for a moment, such as an Edit
 * button hidden while its editor was open. Attach `ref` to the button and call
 * `request()` alongside the state change that brings it back; focus moves once
 * the button is on screen again.
 */
export function useFocusReturn() {
  const ref = useRef<HTMLButtonElement>(null);
  const pending = useRef(false);
  const [, setRequests] = useState(0);

  useEffect(() => {
    if (pending.current && ref.current) {
      pending.current = false;
      ref.current.focus();
    }
  });

  return {
    ref,
    request: () => {
      pending.current = true;
      setRequests((n) => n + 1);
    },
  };
}
